import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { challenge as ChallengeGen } from '@valvur/shared-grpc';
import { CtaButtonComponent } from '../../../../shared/components/ui/cta-button/cta-button.component';

@Component({
  selector: 'app-course-info',
  standalone: true,
  imports: [CommonModule, TranslatePipe, CtaButtonComponent],
  templateUrl: './course-info.component.html',
  styleUrl: './course-info.component.scss',
})
export class CourseInfoComponent {
  course = input<ChallengeGen.Course | null>(null);
  showJoinButton = input<boolean>(false);
  showCancelButton = input<boolean>(false);
  isJoinPending = input<boolean>(false);
  isLeavePending = input<boolean>(false);
  joinCourse = output<void>();
  leaveCourse = output<void>();
}
